// extracted by mini-css-extract-plugin
export default {"loading_fs_text":"loading_loading_fs_text__bQTOx","loading_size_img_logo":"loading_loading_size_img_logo__DnN8g","loading_container":"loading_loading_container__AfNDn"};